/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Plh_Col_QtyInputs */

const vi_sl_plh_col_qty = /** @type {(inputs: Sl_Plh_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL lấy (kg)`)
};

/**

* @param {Sl_Plh_Col_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_plh_col_qty = /** @type {((inputs?: Sl_Plh_Col_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Plh_Col_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_plh_col_qty(inputs)
});